<template>
  <div>
    <el-menu
      router
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
    >
      <el-submenu index="1">
        <span slot="title">
          <i class="el-icon-lock"></i>
          <span>权限管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/system/user">
            <i class="el-icon-s-custom"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/system/permission">
            <i class="el-icon-top"></i>
            <span slot="title">功能权限</span>
          </el-menu-item>
          <el-menu-item index="/system/role">
            <i class="el-icon-bottom"></i>
            <span slot="title">角色管理</span>
          </el-menu-item>
          <el-menu-item index="/system/userPermission">
            <i class="el-icon-bottom"></i>
            <span slot="title">权限分配</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style scoped>
/* #sideNav .el-menu-item{
        text-align:left
    } */
</style>
